import {useStaticConfig} from './useStaticConfig';

export function useBusinessDayStartTimeMinutes(): number | null {
  const config = useStaticConfig();

  if (!config) {
    return null;
  }

  return config.businessDayStartTimeMinutes;
}
